import React, { Component } from 'react';
import ReactGA from 'react-ga';
import $ from 'jquery';
import './App.css';
import Header from './Components/Header';
import Footer from './Components/Footer';
import About from './Components/About';
import Resume from './Components/Resume';
import Contact from './Components/Contact';
import Testimonials from './Components/Testimonials';
import Portfolio from './Components/Portfolio';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      foo: 'bar',
      resumeData: {}
    };

  }

  getResumeData() {
    $.ajax({
      url: '/resumeData.json',
      dataType: 'json',
      cache: false,
      success: function (data) {
        this.setState({ resumeData: data });
      }.bind(this),
      error: function (xhr, status, err) {
        console.log(err);
        alert(err);
      }
    });
  }

  componentDidMount() {
    this.getResumeData();
    ReactGA.initialize('G-N0FYWW1ZZ1');
    // To Report Page View 
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    return (
      <div className="App">
        <Header data={this.state.resumeData.main} />
        <About data={this.state.resumeData.main} />
        <Resume data={this.state.resumeData.resume} />
        <Portfolio data={this.state.resumeData.portfolio} />
        <Testimonials data={this.state.resumeData.testimonials} />
        {/* <Contact data={this.state.resumeData.main}/> */}
        <Footer data={this.state.resumeData.main} />
      </div>
    );
  }
}

export default App;

// {
//         "title": "Disney-Plus Clone",
//         "category": "Disney-Plus Clone built with ReactJS",
//         "image": "https://uploads-ssl.webflow.com/60c44970507914cffa690e76/60d2cf4e540defaa48e86863_disney3.png",
//         "url": "https://disney-plus-clone-5841.web.app/"
//       },

// {
//         "title": "Facebook Clone",
//         "category": "Facebook Clone built with ReactJS",
//         "image": "https://uploads-ssl.webflow.com/60c44970507914cffa690e76/60d2cf3e2673563e06c3c015_facebook.png",
//         "url": "https://facebook-clone-d8951.web.app/"
//       },
// {
//     "title": "Gmail Clone",
//     "category": "Gmail Clone built with ReactJS",
//     "image": "https://uploads-ssl.webflow.com/60c44970507914cffa690e76/60d2cf3b97a26dce6fce4be0_drive.png",
//     "url": "https://clone-fee96.web.app/"
//   },


// {
//   "title": "Messenger Clone",
//   "category": "Facebook-Messenger Clone built with ReactJS",
//   "image": "https://uploads-ssl.webflow.com/60c44970507914cffa690e76/60d2cf326f8fc06b09142924_messenger.png",
//   "url": "https://facebook-messenger-clone-c1d9d.web.app/"
// },
//   {
//   "title": "Linked In Clone",
//   "category": "Linked In Clone built with ReactJS",
//   "image": "https://uploads-ssl.webflow.com/60c44970507914cffa690e76/60d2cf3ae20d96e9d456cada_linkedin.png",
//   "url": "https://linkedin-clone-cff40.web.app/"
// }